module.exports = __webpack_public_path__ + "img/fashion_56.864ed948.jpg";